import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './Header.css';
import logo from '../../logo.jpg';

const Header = () => {

  useEffect(() => {
  }, [])

  const navigate = useNavigate();

  return (
    <header className="app-header">
      <div className="header-container">
        <img src={logo} className="app-logo" alt="Trust Search" onClick={() => navigate('/')} />
      </div>
    </header>
  )
}

export default Header
